<template lang="pug">
div( v-if="cliente" )
  .d-flex.align-items-center.flex-wrap.gap-1
    span.span-label Cliente:
    span.mr-2(
      v-if="cliente.tipo_cliente === 1"
    ) {{ cliente.nombre }} {{ cliente.apellido }}
    span.mr-2( v-else ) {{ cliente.razon_social }}
    span.separator //
    span.span-label.ml-2 RUT:
    span {{ cliente.rut }}
</template>

<script>
export default {
  props: {
    cliente: Object,
  },
}
</script>

<style lang="scss" scoped>
.span-label {
  font-weight: bold;
  color: #23201C;
}
.separator {
  color: #888;
  margin: 0 4px;
}
</style>
